<template>
  <div class="authorize-expenses">
    <v-row>
      <v-col md="4">
        <v-select
          v-model="filter.account"
          :items="allFinanceAccounts"
          small-chips
          color="primary"
          label="Select Finance Account"
          hide-details
          dense
          filled
          rounded
          solo
          background-color="transparent"
          item-value="id"
          item-text="name"
          class="ml-4 mt-4"
          @change="handleTourAfterClick"
        ></v-select>
      </v-col>
    </v-row>
    <IntractDataTable
      v-if="filter.account"
      title="Authorize Pending Expenses"
      :headers="headers"
      :sort-options="sortOptions"
      :endpoint="pendingAuthorizationExpenses"
      :filter-fields="filterFields"
      :export-url="exportPendingAuthorizationExpenses"
      :export-fields="getExportFields"
      @getAllItemsFunction="(f) => (getAllItems = f)"
      @handleClick="handleClick"
      can-export
      id="authorize-table"
    >
      <template v-slot:item.description="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{
                item.description.length > 26
                  ? item.description.substring(
                      0,
                      Math.min(item.description.length, 25)
                    ) + " ..."
                  : item.description
              }}
            </span>
          </template>
          <span>{{ item.description }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.amount="{ item }">
        <span
          :class="item.transaction_type == 'E' ? 'red--text' : 'green--text'"
          ><strong>{{ "₹" + item.amount }}</strong></span
        >
      </template>
      <template v-slot:item.actions="{ item }">
        <div>
          <v-btn text color="green" @click.stop="showAuthorizationDialog(item, true)"
            >Authorize</v-btn
          >
          <v-btn text @click.stop="showAuthorizationDialog(item, false)" color="red"
            >Reject</v-btn
          >
        </div>
      </template>
    </IntractDataTable>


    <FinanceTransactionDialog
      @closeDialog="closeDialog"
      :record_id="record_id"
      :dialog="dialog"
      :adding="is_adding"
      :allFinanceAccounts="allFinanceAccounts"
      :viewOnlyMode="true"
    >
    </FinanceTransactionDialog>

    <ConfirmationDialog
      :visible="dialogData.visible"
      :title="
        dialogData.authorize == true
          ? 'Are you sure you want to authorize this expense?'
          : 'Are you sure you want to reject this expense?'
      "
      :description="
        dialogData.authorize == true
          ? 'This will create an expense transaction and deduct the expense amount from your account balance.'
          : 'This action will delete the expense from the system. This cannot be undone'
      "
      successText="Proceed"
      failureText="Cancel"
      @successCallback="authorizeExpense(dialogData.authorize)"
      @failureCallback="closeAuthorizationDialog"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import IntractDataTable from "@components/widgets/generics/IntractDataTable";
import Helper from "@utils/misc";
import api from "@api/index";
import moment from "moment";
import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
import FinanceTransactionDialog from "@components/finance/FinanceTransactionDialog.vue";
import TourHelper from "@utils/tour_helper";

export default {
  name: "AuthorizeExpenses",
  components: {
    IntractDataTable,
    ConfirmationDialog,
    FinanceTransactionDialog,
  },
  data() {
    return {
      endpoints: endpoints,
      Helper: Helper,
      filterFields: {},
      moment: moment,
      allFinanceAccounts: [],
      getAllItems: null,
      filter: {
        account: null,
      },

      is_adding: false,
      record_id: null,
      dialog: false,


      sortOptions: [
        ["transaction_mode", "transaction_mode__type"],
        ["creator", "creator__full_name"],
        ["category", "category__title"],
      ],

      headers: [
        {
          text: "Description",
          value: "description",
          align: "start",
          sortable: false,
        },
        {
          text: "Category",
          value: "category",
          sortable: true,
          align: "center",
        },
        {
          text: "Payment Mode",
          value: "transaction_mode",
          sortable: true,
          align: "center",
        },
        {
          text: "Invoice No.",
          value: "invoice_number",
          sortable: false,
          align: "center",
        },
        {
          text: "Paid To",
          value: "payee",
          sortable: false,
          align: "center",
        },
        {
          text: "Date",
          value: "transaction_date",
          align: "center",
          sortable: true,
        },
        {
          text: "Amount",
          value: "amount",
          align: "center",
          sortable: true,
        },
        {
          text: "Actions",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      
      paymentModes: [
        {
          type: 0,
          title: "Cash"
        },
        {
          type: 1,
          title: "Cheque"
        },
        {
          type: 2,
          title: "DD"
        },
        {
          type: 3,
          title: "NEFT/RTGS"
        },
        {
          type: 4,
          title: "Online/Net Banking"
        },
        {
          type: 5,
          title: "Debit Card"
        },
        {
          type: 6,
          title: "Credit Card"
        }
      ],
      dialogData: {
        expense: null,
        authorize: null,
        visible: false,
      },
      staff: null,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "accessToken",
      "isLoading",
      "currentInstitution",
    ]),
    pendingAuthorizationExpenses() {
      return Helper.addUrlParams(endpoints.financeTransactions, [
        "transaction_type__in=E",
        "is_authorized=false",
        `account__in=${this.filter.account}`,
        `account__authorizers=${this.currentUser.id}`
      ]);
    },
    exportPendingAuthorizationExpenses() {
      return Helper.addUrlParams(endpoints.financeTransactions + "export/", [
        "transaction_type=E",
        "is_authorized=false",
        `account__in=${this.filter.account}`,
      ]);
    },
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
    getExportFields() {
      return {
        Date: {
          field: "transaction_date",
          callback: (value) => {
            return this.moment(value).format("D MMM, YYYY");
          },
        },
        Category: "category.title",
        Amount: "amount",
        Account: {
          field: "account",
          callback: (id)=>{
            return this.allFinanceAccounts.find(x => x.id == id)?.name;
          }
        },
        "Payment Mode": {
          field: "transaction_mode.type",
          callback: (value) => {
            return this.paymentModes[value].title;
          },
        },
        "Paid To": {
          field: "payee",
          callback: (value) => {
            return value || "-";
          },
        },
        "Created by": "creator.full_name",
        "Created on": {
          field: "created",
          callback: (value) => {
            return this.moment(value).format("D MMM, YYYY");
          },
        },
        "Updated by": {
          field: "updator.full_name",
          callback: (value) => {
            return value || "-";
          },
        },
        "Updated on": {
          field: "updated",
          callback: (value) => {
            return this.moment(value).format("D MMM, YYYY");
          },
        },
        "Invoice Number": {
          field: "invoice_number",
          callback: (value) => {
            return value || "-";
          },
        },
        "Manager": {
          field: "manager",
          callback: (id)=>{
            return this.staff.find(x=>x.id==id)?.full_name;
          }
        },

        Description: "description",
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to authorize expenses", description: "Authorize all your expenses from this section.Click on row to edit expense.", videoLink: "https://youtube.com"});
        // steps.push({id: '2', description: "Add your income by filling neccessary information", el: '#add-income'});
        TourHelper.startTour(this, "authorize", steps);
    },

    handleTourAfterClick(){
        var steps = [];
        steps.push({id: '1', description: "Click on <span style='color:green;'>authorize</span> to authorize the expenses or <span style='color:red;'>reject</span> to decline the expense",el: '#authorize-table',position:'top', videoLink: "https://youtube.com"});
        TourHelper.startTour(this, "authorize__after__click", steps);
    },

    handleClick(value) {
      this.dialog = true;
      this.record_id = value.id;
    },

    closeDialog() {
      this.is_adding = false;
      this.record_id = null;
      this.dialog = false;
    },

    async getAllFinanceAccounts() {
      this.allFinanceAccounts = await api.call(
        this.essentials,
        endpoints.financeAccounts
      );
    },

    async showAuthorizationDialog(item, authorize) {
      var response = await api.call(
        this.essentials,
        endpoints.financeTransactions + item.id + "/"
      );
      if (response) {
        this.dialogData.expense = response;
        this.dialogData.authorize = authorize;
        this.dialogData.visible = true;
      }
    },

    async closeAuthorizationDialog() {
      this.dialogData.authorize = null;
      this.dialogData.expense = null;
      this.dialogData.visible = false;
    },

    async getAllStaff() {
      var url = endpoints.getAllStaff + "?all=true";
      this.staff = await api.call(this.essentials, url);
    },

    async authorizeExpense(authorized) {
        // var response;
      var url =
        endpoints.financeTransactions + this.dialogData.expense.id + "/";
      if (!authorized) {
        await api.call(this.essentials, url, api.Methods.DELETE);
        // console.log(response);
      } else {
          var obj = this.dialogData.expense;
          obj.is_authorized = true;
        await api.call(this.essentials, url, api.Methods.PUT, obj);
        // console.log(response);
      }
      this.getAllItems();

      this.closeAuthorizationDialog();
      return;
    },
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
  },
  created() {
    this.getAllFinanceAccounts();
    this.getAllStaff();
    this.handleTour();
  },
};
</script>